import DocumentsUploadedViewModel from "../components/documentsUploadedViewModel";
import { Router } from "@frui.ts/screens";

export const OmissionDocumentsUploadedViewModelNavigationName = "omission_documents";

@Router.registerRoute({
  route: OmissionDocumentsUploadedViewModelNavigationName,
  name: "omission_documents",
})
export default class OmissionDocumentsUploadedViewModel extends DocumentsUploadedViewModel {}
